import { loginHttpClient, refreshHttpClient, withCredentialsClient } from '@/app/shared/services/http-client/http-client.js';
import { appLocalStorage } from '@/app/shared/commonURLs.js';
import {
    refreshHttpClient as refreshHttpClientPhysician
} from "@/app/physician-portal/physician-desktop/shared/services/http-client/http-client.js";

export class LoginService {
    constructor() {
        this.loginAPiPath = appLocalStorage.SecurityServiceUrl + "security/login";
        this.logoutAPiPath = appLocalStorage.SecurityServiceUrl + "security/Logout";
        this.ChangeLangAPiPath = appLocalStorage.SecurityServiceUrl + "security/ChangeUserLanguage";
        this.backofficeUrl = window.origin;

    }
    saveTokenInfo(token) {

        //this.clearLocalStorage();
        this.addDataCache("myToken", "Success");
        this.addDataCache("Token", token);
        this.addDataCache("user", token.User);
        this.addDataCache("perms", token.Perms);
        this.addDataCache("pages", token.Pages);
        this.addDataCache("DisplayName", token.DisplayName);
        this.addDataCache("isFormAuthenticated", token.isFormAuthenticated);
        this.addDataCache("EmployeeID", token.EmployeeID);
        this.addDataCache("UnModuledPages", token.UnModuledPages);
        this.addDataCache("NG_TRANSLATE_LANG_KEY", token.NG_TRANSLATE_LANG_KEY);
        this.addDataCache("sharedUserEntities", token.SharedUserEntities);
        this.addDataCache("UserEntity", token.UserEntity);
        var _localStorageData = {};

        _localStorageData.isChangeLang = true;
        _localStorageData.NG_TRANSLATE_LANG_KEY = token.NG_TRANSLATE_LANG_KEY ?? localStorage.NG_TRANSLATE_LANG_KEY ?? 'en';
        _localStorageData.Token = JSON.stringify(token)
        _localStorageData.pages = token.Pages;
        _localStorageData.UnModuledPages = token.UnModuledPages;
        _localStorageData.EmployeeID = token.EmployeeID;
        _localStorageData.user = token.User;
        _localStorageData.IsFormAuthenticated = token.isFormAuthenticated;
        _localStorageData.perms = token.Perms;
        _localStorageData.DisplayName = token.DisplayName;
        //console.log(_localStorageData)
        _localStorageData.messageOrigin = this.backofficeUrl;
        if (!localStorage.getItem("saveTokenFromAngular")) {
            document
                .getElementById("idMyIframe")
                .contentWindow.postMessage(_localStorageData, "*");
        }

        refreshHttpClient();
        refreshHttpClientPhysician();
    }
    addDataCache(key, data) {
        //check if key and data has value
        if (!key || !data) { return; }
        //incase of data is an object then stringify it 
        if (typeof data === "object") {
            data = JSON.stringify(data);
        }
        //set key and data in Local Storage
        localStorage.setItem(key, data);
    }

    clearLocalStorage() {
        localStorage.clear();
    }

    login(username, password, callback, errCallBack) {
        if (username && password) {
            this.loginForm(username, password, callback, errCallBack);
        }
        else
            this.loginWin(callback, errCallBack);
    }

    loginForm(username, password, callback, errCallBack) {
        username = username.replace(/&/g, "_ANDPERCENT_");
        username = username.replace(/#/g, "_HASH_");
        username = username.replace(/ /g, "_SPACE_");
        username = username.replace(/\+/g, "_PLUS_");
        username = username.replace(/%/g, "_PERCENTAGE_");

        password = password.replace(/&/g, "_ANDPERCENT_");
        password = password.replace(/#/g, "_HASH_");
        password = password.replace(/ /g, "_SPACE_");
        password = password.replace(/\+/g, "_PLUS_");
        password = password.replace(/%/g, "_PERCENTAGE_");

        loginHttpClient.get(this.loginAPiPath + "?username=" + username + "&password=" + password).then(callback).catch(errCallBack);

    }
    loginWin(callback, errCallBack) {
        loginHttpClient.get(this.loginAPiPath).then(callback).catch(errCallBack);
    }
    logout(username, callback) {
        username = username.replace(/&/g, "_ANDPERCENT_");
        username = username.replace(/#/g, "_HASH_");
        username = username.replace(/ /g, "_SPACE_");
        username = username.replace(/\+/g, "_PLUS_");
        username = username.replace(/%/g, "_PERCENTAGE_");
        loginHttpClient.get(this.logoutAPiPath + "?username=" + username).then(callback);
    }
    changeUserLang(IsArabic, entityId, callback, errCallBack) {
        withCredentialsClient().get(this.ChangeLangAPiPath + "?IsArabic=" + IsArabic + "&entityId=" + entityId).then(callback).catch(errCallBack);
    }
}

const loginService = new LoginService();

export { loginService };